import { useState } from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import { useLazyQuery } from "@apollo/client";
import { Modal } from "@aqar-app/react-ui";
import { Icon } from "@/components/icon";

import { GET_VIDEO_ACCESS } from "../../../../graphql/queries/listing";
import { buildFileSrc } from "../../../../lib/helpers";
import config from "../../../../common/config";
import { VIDEO_ORIENTATION } from "../../../../common/constants";
import { useAuthState } from "../../../../contexts/auth/auth.provider";
import LoginAlert, { WarningAlert } from "../../../login-alert";
import styles from "./.module.scss";
import { trackVideoStart } from "@/lib/tracking/trackNavigationEvents";
import { usePath } from "@/contexts/path/path";

function ListingVideo({ videoItem, propertyCategory, listingType }) {
  const thumbnail = videoItem.thumbnail
    ? buildFileSrc(
        `thumbnails/${videoItem.thumbnail}`,
        config.IMAGES_CDN_BASE_URL,
      )
    : undefined;
  const { token } = useAuthState();
  const [previewVideo, setPreviewVideo] = useState(undefined);

  const [getVideoAccess] = useLazyQuery(GET_VIDEO_ACCESS, {
    context: { token },
  });
  const { category } = usePath();

  const getVideoURL = (e) => {
    const video = videoItem.video || "";
    const fileName = `${video}/${video}_${VIDEO_ORIENTATION}.mp4`;

    trackVideoStart({
      listingType: category?.ga_listing_type || listingType,
      category: category?.ga_property_category || propertyCategory,
    });

    if (!token) {
      return Modal.open(
        <LoginAlert text="يرجى تسجيل الدخول لمشاهدة الفيديو" />,
      )(e);
    }

    return getVideoAccess({ variables: { fileName } }).then((res) => {
      const videoURL = res?.data?.User?.getVideoAccess || {};
      setPreviewVideo(videoURL);
    });
  };

  return (
    <div className={styles.videoCard}>
      <div className={styles.videoContainer}>
        {!previewVideo && (
          <div className={styles.preview}>
            {thumbnail && (
              <Image alt={`فيديو للإعلان`} unoptimized src={thumbnail} fill />
            )}

            <Icon
              name="playVideo"
              className={styles.playVideoIcon}
              onClick={getVideoURL}
            />
          </div>
        )}
        {previewVideo && (
          <video
            controls
            autoPlay
            src={previewVideo}
            width="100%"
            height="100%"
            onError={(e) =>
              Modal.open(
                <WarningAlert text=" عذراً الفيديو غير متاح الآن، تجري الآن معالجة الفيديو المرفوع قد تستغرق المعالجة حتى 5 دقائق." />,
              )(e)
            }
          >
            <track kind="captions" />
          </video>
        )}
      </div>
    </div>
  );
}

ListingVideo.propTypes = {
  videoItem: PropTypes.shape({
    video: PropTypes.string,
    thumbnail: PropTypes.string,
  }),
};

ListingVideo.defaultProps = {
  videoItem: {},
};

export default ListingVideo;
